import { NavigationTabs } from './NavigationTabs.js';

export class LiveChatPanel {
	constructor(state, options = {}) {
		this.state = state;
		this.options = {
			position: options.position || 'right',
			...options,
		};
		this.element = null;
		this.navigationTabs = null;
		this.currentViewComponent = null;
		this.viewRegistry = {};
		this._unsubscribe = null;
		this._expanded = false;
	}

	registerView(name, ViewClass) {
		this.viewRegistry[name] = ViewClass;
	}

	render() {
		this.element = document.createElement('div');
		this.element.className = `liveChat-panel liveChat-panel-${this.options.position}`;

		this.element.innerHTML = `
			<div class="liveChat-panel-content">
				<div class="liveChat-panel-views"></div>
				<div class="liveChat-panel-nav"></div>
			</div>
		`;

		this.options.onToggleExpand = () => this._toggleExpand();
		this.options.isExpanded = () => this._expanded;

		this.navigationTabs = new NavigationTabs(this.state, this.options);
		const navContainer = this.element.querySelector('.liveChat-panel-nav');
		navContainer.appendChild(this.navigationTabs.render());

		this._renderCurrentView();

		this._unsubscribe = this.state.subscribe((type) => {
			if (type === 'viewChange') {
				this._renderCurrentView();
			}
		});

		return this.element;
	}

	_toggleExpand() {
		this._expanded = !this._expanded;
		this.element.classList.toggle('liveChat-panel-expanded', this._expanded);

		const menuIcon = this.element.querySelector(
			'.liveChat-expand-window-btn iconify-icon'
		);
		const menuLabel = this.element.querySelector(
			'.liveChat-expand-window-btn span'
		);
		if (menuIcon)
			menuIcon.setAttribute(
				'icon',
				this._expanded ? 'ph:arrows-in' : 'ph:arrows-out'
			);
		if (menuLabel)
			menuLabel.textContent = this._expanded
				? 'Collapse window'
				: 'Expand window';
	}

	_renderCurrentView() {
		const viewsContainer = this.element.querySelector('.liveChat-panel-views');
		const navContainer = this.element.querySelector('.liveChat-panel-nav');

		if (this.currentViewComponent && this.currentViewComponent.destroy) {
			this.currentViewComponent.destroy();
		}

		viewsContainer.innerHTML = '';

		// Collapse expanded state when leaving chat view
		if (this.state.currentView !== 'chat' && this._expanded) {
			this._expanded = false;
			this.element.classList.remove('liveChat-panel-expanded');
		}

		const ViewClass = this.viewRegistry[this.state.currentView];
		if (ViewClass) {
			this.currentViewComponent = new ViewClass(this.state, this.options);
			viewsContainer.appendChild(this.currentViewComponent.render());
		} else {
			viewsContainer.innerHTML = `<div class="liveChat-empty-state">
				<p>View not found: ${this.state.currentView}</p>
			</div>`;
		}

		// Hide nav in chat, prechat and feedback views
		if (navContainer) {
			const hideNav =
				this.state.currentView === 'chat' ||
				this.state.currentView === 'prechat' ||
				this.state.currentView === 'feedback';
			navContainer.style.display = hideNav ? 'none' : '';
		}
	}

	show() {
		if (this.element) {
			requestAnimationFrame(() => {
				this.element.classList.add('open');
			});
		}
	}

	hide() {
		if (this.element) {
			this.element.classList.remove('open');
		}
	}

	setHeader(headerContent) {
		const header = this.element.querySelector('.liveChat-panel-header');
		if (header) {
			header.innerHTML = headerContent;
		}
	}

	destroy() {
		if (this._unsubscribe) {
			this._unsubscribe();
		}
		if (this.navigationTabs) {
			this.navigationTabs.destroy();
		}
		if (this.currentViewComponent && this.currentViewComponent.destroy) {
			this.currentViewComponent.destroy();
		}
		if (this.element && this.element.parentNode) {
			this.element.parentNode.removeChild(this.element);
		}
	}
}
